import { Component, OnInit, input, output } from '@angular/core';
import { Html5PlayerVars } from '@teamfoster/sdk/html5-video-player';
import { Url } from 'url';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: false,
})
export class HeaderComponent {
  readonly imageUrl = input<string>();
  readonly title = input<string>('');
  readonly subtitle = input<string>('');
  readonly text = input<string>('');
  readonly cssClass = input<string>('');
  readonly buttons = input<
    {
      text: string;
      url?: string;
      routerLink?: string[];
    }[]
  >([]);
  readonly skewBottom = input<boolean>(false);
  readonly videoBg = input<string>();
  readonly playerVars = input<Html5PlayerVars>({
    autoplay: true,
    controls: false,
    muted: true,
    loop: true,
  });
  readonly inView = output<any>();
  inviewPort = false;

  constructor() {}

  inViewChange(e: boolean) {
    this.inviewPort = e;
    if (e) {
      this.inView.emit(null);
    }
  }
}
